module.exports = __webpack_public_path__ + "static/media/double-left-blue.828e1f55.svg";